export default class ExistClientRequest {
  public firstSurname: string | null
  public secondSurname: string | null
  public name: string | null
  public sex: string | null
  public documentType: string | null
  public documentNumber: string | null
  public birthDay: string | null

  constructor(data: ExistClientRequest) {
    if (!data.firstSurname) throw new Error('firstSurname is required')
    // if (!data.secondSurname) throw new Error('secondSurname is required')
    if (!data.name) throw new Error('name is required')
    if (!data.sex) throw new Error('sex is required')
    if (!data.documentType) throw new Error('documentType is required')
    if (!data.documentNumber) throw new Error('documentNumber is required')
    if (!data.birthDay) throw new Error('birthDay is required')

    this.firstSurname = data.firstSurname
    this.secondSurname = data.secondSurname
    this.name = data.name
    this.sex = data.sex
    this.documentType = data.documentType
    this.documentNumber = data.documentNumber
    this.birthDay = data.birthDay
  }
}
